import { Injectable } from '@angular/core';



@Injectable({
  providedIn: 'root'
})
export class UserStorageService {

  setUserData(data): void {


    let date = new Date().toLocaleString();
    localStorage.setItem('start_token', JSON.stringify(Date.now()));
    localStorage.setItem('token', JSON.stringify(data.user_token));
    localStorage.setItem('user', JSON.stringify(data.user));

  }


  ifLoggedIn():boolean{
    return !!localStorage.getItem('token')
  }


  checkUser(): boolean {
    let token = JSON.parse(localStorage.getItem('token'));

    // const min = 1000 * 60;
    // const hour = min * 60;
    // const day = hour * 24;
    // const year = day * 365;
   // let date = Date();
   // let convertDateStr = date.toString();

    if (token && token.expires_in) {
      let start_expire =
        parseInt(localStorage.getItem('start_token')) + token.expires_in;
      

      if (start_expire < Date.now()) return false;
        //console.log("Date", convertDateStr);

      return true;


    } else {
      return false;
    }
  }


}



